module.exports = __webpack_public_path__ + "img/img_throw_4@3x.6437e4a4.png";